let env = {};

env.baseURL = 'https://api.prontidao.ares-despacho.com.br/api/v1/';
env.normalURL = 'https://api.prontidao.ares-despacho.com.br/';
env.wsHost = 'websocket.prontidao.ares-despacho.com.br';
env.wsKey = 'prontidao-key';
env.mode = 'production';
env.wsPort = '443';
env.googleApiKey = 'AIzaSyBmngiC-7NbxzKxUzwCE0NfKzWNSDxr9zc';

export default env
